import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25213f7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nb-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nb-header-bg" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nb-header__header-wrapper" }, [
  /*#__PURE__*/_createElementVNode("a", {
    class: "nb-header__logo-wrapper",
    href: "/"
  }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: "https://faktura.ambita.com/static/media/ambita-logo-white.fb6c618d.svg",
      class: "nb-header__logo",
      alt: "ambita logo"
    })
  ])
], -1))
const _hoisted_4 = {
  key: 0,
  class: "dataContent"
}
const _hoisted_5 = { class: "authButtons" }

import { useIsAuthenticated } from '@/composition-api/useIsAuthenticated';
import { useMsalAuthentication } from '@/composition-api/useMsalAuthentication';
import { InteractionType } from '@azure/msal-browser';
import { loginRequest } from '@/authConfig';
import { ref, watch } from 'vue';
import SignOutButton from '../SignOut/SignOutButton.vue';
import SignInButton from '@/components/SignIn/SignInButton.vue';
import { RouterService } from '@/router';
import APIServices from '@/services/apiFetch';
import SearchResultsCard from '@/components/Cards/SearchResultsCard/SearchResultsCard.vue';
import SearchBar from '@/components/SearchBar/SearchBar.vue';
import { UserType } from '@/typings/User/user';
import { TaskTypes } from '@/typings/task/task';

// This one is used for signin/out buttons and follows documentation
// https://github.com/AzureAD/microsoft-authentication-library-for-js/pull/4188/files/530ff12e92e8302315d5d61c18c57d378fff5b03#diff-605a410eece21bbecb5c25136d1f09a08b6d6c92f083ede1e9d5f9ca9695517d

export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const isAuthenticated = useIsAuthenticated();
// Might be able to be removed after Guard.ts implementation
const msalAuth = useMsalAuthentication(InteractionType.Redirect, loginRequest);
const msalResult = msalAuth.result;

let authToken;

// Set to localstorage for easier use with API calls. Can probably use the localstorage that is set by usemsal instead
// Or create a simple store: https://devblogs.microsoft.com/azure-sdk/vue-js-user-authentication/
if (msalResult) {
  watch(msalResult, () => {
    authToken = msalResult?.value?.accessToken;
    localStorage.setItem('Support-User', authToken);
  });
}

const fetchedData = ref<UserType.User[] | TaskTypes.Task>();
const searchQuery = ref<string>('');
const displayDropdownCard = ref<boolean>();

let throttleDelay = -1;
const throttleDelayMs = 300;

watch(searchQuery, () => {
  if (throttleDelay > -1) {
    window.clearTimeout(throttleDelay);
  }

  if (searchQuery.value.length === 0) {
    return;
  }

  throttleDelay = window.setTimeout(() => {
    fetchData(searchQuery?.value);
  }, throttleDelayMs);
});

const loadAndShow = (item) => {
  searchQuery.value = '';
  displayDropdownCard.value = false;

  if (item?.taskId) {
    RouterService.routeTo('Task', {
      taskId: item?.taskId,
    });
  } else {
    RouterService.routeTo('User', {
      guid: item?.guid,
    });
  }
};

const fetchData = async function (searchQuery) {
  let result: UserType.User = (await APIServices.fetchBySearchQuery(searchQuery)) as UserType.User;

  if (result) {
    if (Array.isArray(result)) {
      fetchedData.value = result.flat();
    } else {
      fetchedData.value = [result];
    }
    displayDropdownCard.value = true;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", null, [
      _createVNode(SearchBar, {
        modelValue: searchQuery.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event))
      }, null, 8, ["modelValue"])
    ]),
    (displayDropdownCard.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fetchedData.value, (value, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: value.id
            }, [
              _createVNode(SearchResultsCard, {
                value: value,
                index: index,
                onClick: () => loadAndShow(value)
              }, null, 8, ["value", "index", "onClick"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (_unref(isAuthenticated))
        ? (_openBlock(), _createBlock(SignOutButton, { key: 0 }))
        : (_openBlock(), _createBlock(SignInButton, { key: 1 }))
    ])
  ]))
}
}

})